import AppConstatnt from '../../../../../config/app.constants';

class PrintController {
    /*@ngInject*/
    constructor(Auth, AtmResidualService, $translate, Modal) {
        this.AtmResidualService = AtmResidualService;
        this.$translate = $translate;
        this.Modal = Modal;
        this.model = {
            branchId: null,
            endDate: null,
            searchText: null,
            startDate: null,
            vaultDate: null,
            currentStats: null,
            residualsCompletedApprovalList: [],
            fundingSource: null,
            limit: 1000,
            offset: 0,
            totalApprovedRecords: 0,
            gettingResidualCompletedApprovalList: false
        }
    }

    $onInit() {
        let printData = undefined;

        if (window.opener && window.opener.w && window.opener.w.printData) {

            printData = window.opener.w.printData;
            this.model.currentStats = printData.currentStats;
            this.model.searchText = printData.searchText;
            this.model.branchId = printData.branchId;
            this.model.startDate = printData.startDate;
            this.model.endDate = printData.endDate;
            this.model.vaultDate = printData.vaultDate;
            this.model.timezone = printData.timezone;
            this.model.fundingSource = printData.fundingSource;
            this.model.denoms = printData.denoms;
            this.model.user = printData.user || null;
            this.model.sectionType = printData.sectionType;
            if (this.model.currentStats === 'authorizedResidual') {
                this.model.gettingResidualCompletedApprovalList = true;
                const serviceCall = this.model.sectionType === 'deposit'
                    ? this.AtmResidualService.getDepositsCompletedApproval(
                        this.model.searchText,
                        this.model.fundingSource.Id,
                        this.model.timezone,
                        this.model.startDate,
                        this.model.endDate,
                        this.model.user,
                        this.model.denoms,
                        this.model.offset,
                        this.model.limit
                    )
                    : this.AtmResidualService.getResidualsCompletedApproval(
                        this.model.searchText,
                        this.model.fundingSource.Id,
                        this.model.timezone,
                        this.model.startDate,
                        this.model.endDate,
                        this.model.denoms,
                        this.model.user,
                        this.model.offset,
                        this.model.limit
                    );

                return serviceCall.then((data) => {
                    this.model.residualsCompletedApprovalList = data;
                    this.model.totalApprovedRecords = data.totalRecords;
                    this.print();
                })
                    .catch((err) => {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                        else {
                            this.Modal.errorModal(err);
                        }
                    })
                    .finally(() => {
                        this.model.gettingResidualCompletedApprovalList = false;
                    })
            }
        }
    }

    print() {
        setTimeout(() => {
            window.print();
        }, 1500)
    }
}

export default PrintController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/final_residual_count_commit/print/final_residual_count_commit_print.controller.js